import React from 'react';
import { Content } from './Content';
import { Resolution886ReportProvider } from '@/context/Resolution886Report';

export function Resolution886(): JSX.Element {
	return (
		<Resolution886ReportProvider>
			<Content />
		</Resolution886ReportProvider>
	);
}
